import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchOnlyData, updateData } from "../../utility/adminApi";
import SelectLabels from "../../components/SelectLabelsCurrency";

function CurrencySetting({ setCurrencySymbol }) {
  const queryClient = useQueryClient();
  const [currencyId, setCurrencyId] = useState();
  const [newCountryCode, setNewCountryCode] = useState();
  const [data, setData] = useState();

  const { data: defaultId } = useQuery({
    queryKey: ["defaultId"],
    queryFn: () => fetchOnlyData("currency-settings"), // Call manually
    staleTime: 1000 * 60 * 50, // Keep fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache for 60 minutes
    retry: 1,
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: allCurrency } = useQuery({
    queryKey: ["allCurrency"],
    queryFn: () => fetchOnlyData("currency-settings/currencies"), // Call manually
    staleTime: 1000 * 60 * 50, // Keep fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache for 60 minutes
    retry: 1,
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    console.log(defaultId);
    setCurrencySymbol(defaultId?.currency?.symbol);
    setCurrencyId(defaultId?.currency_id);
    setNewCountryCode(defaultId?.currency?.code);
  }, [defaultId, allCurrency]);

  const currencyUpdate = useMutation({
    mutationFn: (data) =>
      updateData(`currency-settings/update/`, defaultId.id, data),
    onSuccess: (response) => {
      queryClient.refetchQueries({ queryKey: ["defaultCurrency", "admin"] });
      // queryClient.invalidateQueries({ queryKey: ["defaultCurrency"] });
      console.log(response);
    },
  });

  const handleCountryChange = (value) => {
    setNewCountryCode(value?.code);
    setCurrencySymbol(value?.symbol);
    setData();
    currencyUpdate.mutate({ currency_id: value?.id });
  };

  return (
    <div className="flex flex-row items-center gap-4 my-3">
      <h3 className="text-lg font-medium">Currency Setting:</h3>
      <div className="flex gap-1 items-center">
        <h3 className="font-bold text-lg">{newCountryCode}</h3>

        <SelectLabels
          previousValue={currencyId}
          categoryData={allCurrency}
          text="Select a Country"
          valueKey="id"
          labelKey="country"
          onSelectChange={handleCountryChange}
        />
      </div>
    </div>
  );
}

export default CurrencySetting;
